import axios from "../../axios";

export function web_initialization() {
    return (async (dispatch) => {
        try {
            dispatch({ type: "WEB_INITIALIZATION_PENDING" });

            let res = await axios.get(`Webs/initialization`);
            let { statistics, user, zones, sessions, actives } = res.data;
            let { marshals_online, reports_new, reports_today, summons_new, summons_today, tours_today } = statistics
            dispatch({
                type: "WEB_INITIALIZATION_FULFILLED", payload: res
            });

            dispatch({
                type: "SESSION_ONLINE_COUNT", payload: {
                    data: { sessions, marshals_online },
                    error: null
                }
            });
            dispatch({
                type: "REPORTS_STATISTICS_COUNT", payload: {
                    data: { reports_new, reports_today },
                    error: null
                }
            });
            dispatch({
                type: "SUMMONS_STATISTICS_COUNT", payload: {
                    data: { summons_new, summons_today },
                    error: null
                }
            });
            dispatch({
                type: "TOURS_STATISTICS_COUNT", payload: {
                    data: tours_today,
                    error: null
                }
            });

            dispatch({
                type: "ENDUSER_ONLINE_INFO", payload: {
                    data: user,
                    error: null
                }
            });
            dispatch({
                type: "ZONES_INFO_INIT", payload: {
                    data: zones,
                    error: null
                }
            });

            dispatch({
                type: "TRACKERS_ACTIVES_INIT", payload: {
                    data: { actives },
                    error: null
                }
            });
        }
        catch (e) {
            console.log(e);
            dispatch({
                type: "WEB_INITIALIZATION_REJECTED", payload: {
                    response: null,
                    error: e
                }
            })
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux/actions/web.js